import React from 'react';
import {
  fontSans,
  footerBg,
  footerPrimaryButtonStyle,
  footerSecondaryButtonStyle,
  formatProductChangeCount,
  pageGutter,
  stickyFooterHeight
} from './requestChangesStyles';

export default function RequestChangesStickyBar({ changeCount, onAddProduct, onContinue }) {
  return (
    <div
      className="no-print request-changes-sticky-bar"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999,
        boxSizing: 'border-box',
        backgroundColor: footerBg,
        minHeight: stickyFooterHeight,
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 -4px 14px rgba(0, 0, 0, 0.16)'
      }}
    >
      <style>{`
        .request-changes-sticky-actions {
          display: inline-flex;
          align-items: center;
          gap: 16px;
          flex-shrink: 0;
        }
        .request-changes-sticky-add:focus-visible {
          outline: 2px solid #fff;
          outline-offset: 2px;
        }
        .request-changes-sticky-continue:focus-visible {
          outline: 2px solid #fff;
          outline-offset: 2px;
        }
        @media screen and (max-width: 768px) {
          .request-changes-sticky-copy {
            display: none !important;
          }
          .request-changes-sticky-inner {
            justify-content: flex-end !important;
            padding-left: 24px !important;
            padding-right: 24px !important;
          }
          .request-changes-sticky-actions {
            width: 100%;
            justify-content: flex-end;
            gap: 14px;
          }
        }
      `}</style>
      <div
        className="request-changes-sticky-inner"
        style={{
          width: '100%',
          boxSizing: 'border-box',
          minHeight: stickyFooterHeight,
          padding: `17px ${pageGutter}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16
        }}
      >
        <div
          className="request-changes-sticky-copy"
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '6px 10px',
            minWidth: 0
          }}
        >
          <div className="request-changes-sticky-count" style={{
            fontFamily: fontSans,
            fontSize: 13,
            color: 'white',
            letterSpacing: '0.01em',
            whiteSpace: 'nowrap'
          }}>
            {formatProductChangeCount(changeCount)}
          </div>
          <span aria-hidden="true" style={{ width: 1, height: 12, backgroundColor: 'rgba(255,255,255,0.28)' }} />
          <div className="request-changes-sticky-helper" style={{
            fontFamily: fontSans,
            fontSize: 12,
            color: 'rgba(255,255,255,0.72)',
            lineHeight: 1.3
          }}>
            Dates, times + other details on the next step
          </div>
        </div>
        <div className="request-changes-sticky-actions">
          <button
            type="button"
            className="request-changes-sticky-add"
            onClick={onAddProduct}
            style={footerSecondaryButtonStyle}
          >
            + Add New Product
          </button>
          <button
            type="button"
            className="request-changes-sticky-continue"
            onClick={onContinue}
            style={footerPrimaryButtonStyle}
          >
            Continue →
          </button>
        </div>
      </div>
    </div>
  );
}
